import { IImportCreatePartManufacturersData, IImportManufacturer } from 'bom/types';

export const mapCreateImportManufacturersData = (
  data: IImportManufacturer[],
  partImportId: number
): IImportCreatePartManufacturersData => {
  const { map, omit } = data?.reduce(
    (acc, record) => {
      acc.map[record.name] = record.assignTo?.id || '';
      acc.omit[record.name] = +record.omit;

      return acc;
    },
    { map: {}, omit: {} }
  ) || { map: {}, omit: {} };

  return {
    partImport: partImportId,
    map,
    omit,
  };
};
